import PageHeader from "../components/PageHeader";
import { volunteers } from "../lib/mockData";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { MapPin, Clock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Volunteer() {
  const apply = (org) => toast.success(`Application sent to ${org}. They'll reach out soon.`);

  return (
    <>
      <PageHeader
        eyebrow="Volunteer"
        title="Give a few hours. Change a life."
        description="Local and remote volunteer opportunities matched to your skills and calendar."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {volunteers.map((v, i) => (
            <Card
              key={v.id}
              data-testid={`volunteer-${v.id}`}
              className={`fade-up stagger-${(i % 6) + 1} rounded-3xl overflow-hidden border-border/60 shadow-none hover:shadow-md transition-shadow group`}
            >
              <div className="h-44 overflow-hidden">
                <img src={v.image} alt={v.org} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="text-xs text-muted-foreground uppercase tracking-wider font-semibold mb-1">{v.org}</div>
                <h3 className="font-display text-xl font-semibold mb-3">{v.role}</h3>
                <div className="flex flex-wrap gap-2 mb-4">
                  {v.skills.map(s => (
                    <Badge key={s} variant="outline" className="rounded-full text-[10px] border-border">
                      {s}
                    </Badge>
                  ))}
                </div>
                <div className="text-sm text-muted-foreground space-y-1.5 mb-5">
                  <div className="flex items-center gap-2"><MapPin size={13} /> {v.location}</div>
                  <div className="flex items-center gap-2"><Clock size={13} /> {v.commitment}</div>
                </div>
                <Button
                  onClick={() => apply(v.org)}
                  data-testid={`volunteer-apply-${v.id}`}
                  className="rounded-full w-full bg-primary hover:bg-primary/90"
                >
                  Apply <ArrowRight size={14} className="ml-1" />
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
}
